<template>
  <v-navigation-drawer app clipped left stateless :value="true">
    <v-list class="picker-list" dense>
      <draggable :value="itemsToAdd" :group="{ name: 'coursesTree', pull: 'clone' }">
        <v-list-item v-for="itemToAdd in itemsToAdd" :key="itemToAdd.title" class="new-draggable-item">
          <v-list-item-action class="icon">
            <v-icon>{{ itemToAdd.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ itemToAdd.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </draggable>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import draggable from 'vuedraggable';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('courses');

export default {
  components: {
    draggable
  },
  computed: {
    ...mapState({
      isDraft: state => state.activeCourseEditTree.course && state.activeCourseEditTree.course.isDraft,
      hasAnyChild: state => state.activeCourseEditTree.course && state.activeCourseEditTree.course.children.length
    }),
    itemsToAdd() {
      return [
        { newElementType: 'lesson', icon: 'mdi-school', title: 'Lekcja' },
        {
          newElementType: 'meeting',
          icon: 'mdi-account-multiple',
          title: 'Spotkanie'
        },
        { newElementType: 'video', icon: 'mdi-video', title: 'Video' },
        { newElementType: 'file', icon: 'mdi-file-multiple', title: 'Plik' },
        {
          newElementType: 'module',
          icon: 'mdi-folder',
          title: 'Moduł'
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.new-draggable-item {
  cursor: pointer;
  opacity: 0.5;
  background: rgba(76, 175, 80, 0.3);
}

.picker-list {
  .new-draggable-item {
    background: none;
    opacity: 1;
  }
}

.draggable {
  .new-draggable-item {
    .icon {
      padding-left: 30px !important;
      margin-right: 14px !important;
      margin-top: 22px !important;
      margin-bottom: 22px !important;
    }
  }
}
</style>
